/**
 * TanStack Query hooks for `four-payout-types-default-campaign-publisher-speci`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys,
	type CreateFourPayoutTypesDefaultCampaignPublisherSpeciBody,
	type ListFourPayoutTypesDefaultCampaignPublisherSpeciResponse,
	type FourPayoutTypesDefaultCampaignPublisherSpeciRow,
} from "./api";

export function useFourPayoutTypesDefaultCampaignPublisherSpeciList(): UseQueryResult<ListFourPayoutTypesDefaultCampaignPublisherSpeciResponse, Error> {
	return useQuery({
		queryKey: fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys.list(),
		queryFn: list,
	});
}

export function useFourPayoutTypesDefaultCampaignPublisherSpeciCreate(): UseMutationResult<FourPayoutTypesDefaultCampaignPublisherSpeciRow, Error, CreateFourPayoutTypesDefaultCampaignPublisherSpeciBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys.all });
		},
	});
}

export function useFourPayoutTypesDefaultCampaignPublisherSpeciDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: fourPayoutTypesDefaultCampaignPublisherSpeciQueryKeys.all });
		},
	});
}
